import React from "react";
import "./shoppedItem.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMultiply } from "@fortawesome/free-solid-svg-icons";
import ItemImage from "../../../../images/test-image.png";

import { useOrder } from "../../../../contexts/OrderContext";

export default function ShoppedItem({ data }) {
  const dropZeros = (price) => parseInt(price) / 1000;

  const { removeFromCart, increaseQuantity, decreaseQuantity, isInProcess } =
    useOrder();

  const allowEdit = !isInProcess();

  function handleRemove() {
    removeFromCart(data.ProductID);
  }

  function handleIncrease() {
    increaseQuantity(data.ProductID);
  }

  function handleDecrease() {
    if (data.Quantity === 1) return;
    decreaseQuantity(data.ProductID);
  }

  function handleMultiRemove(mId) {
    removeFromCart(data.ProductID, mId);
  }

  function handleMultiIncrease(mId) {
    increaseQuantity(data.ProductID, mId);
  }

  function handleMultiDecrease(mId) {
    decreaseQuantity(data.ProductID, mId);
  }

  const multiOptions =
    data.ProductMultiMode === "true"
      ? data.ProductMultiModeDetails.map((val) => (
          <div className="multi-shopped-item" key={val.ProductMultiModeId}>
            <div className="multi-shopped-item-title">{val.SubTitle}</div>
            <span className="item-amount multi-item-amount">
              {allowEdit && (
                <span
                  className="decrease-amount"
                  onClick={() =>
                    val.Quantity !== 1
                      ? handleMultiDecrease(val.ProductMultiModeId)
                      : ""
                  }
                >
                  -
                </span>
              )}
              <span className="item-amount-number">{val.Quantity}</span>
              {allowEdit && (
                <span
                  className="increase-amount"
                  onClick={() => handleMultiIncrease(val.ProductMultiModeId)}
                >
                  +
                </span>
              )}
            </span>
            <div className="multi-shopped-item-price-amount shopped-item-price-amount">
              <span className="multi-shopped-item-price-number">
                {dropZeros(val.Price)}
              </span>
              هزار تومان
            </div>

            {allowEdit && (
              <div
                className="multi-remove-item"
                onClick={() => handleMultiRemove(val.ProductMultiModeId)}
              >
                <FontAwesomeIcon icon={faMultiply} />
              </div>
            )}
          </div>
        ))
      : null;

  return (
    <>
      <div className="shopped-item">
        <img src={data.ProductPicture} alt="" className="item-image" />
        <div className="item-title">
          <span className="shopped-item-name">{data.ProductTitle}</span>
          {data.ProductMultiMode === "false" && (
            <span className="item-amount">
              {allowEdit && (
                <span className="decrease-amount" onClick={handleDecrease}>
                  -
                </span>
              )}
              <span className="item-amount-number">{data.Quantity}</span>
              {allowEdit && (
                <span className="increase-amount" onClick={handleIncrease}>
                  +
                </span>
              )}
            </span>
          )}
        </div>
        <div className="shopped-item-price-amount">
          <span className="shopped-item-price-number">
            {dropZeros(data.Price)}
          </span>
          هزار تومان
        </div>

        {allowEdit && (
          <div className="remove-item" onClick={handleRemove}>
            <FontAwesomeIcon icon={faMultiply} />
          </div>
        )}
      </div>
      <div className="multi-shopped-items">{multiOptions}</div>
    </>
  );
}
